import { render, staticRenderFns } from "./AdClientCreateForm.vue?vue&type=template&id=06c3cefe&"
import script from "./AdClientCreateForm.vue?vue&type=script&lang=ts&"
export * from "./AdClientCreateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports